import React from 'react';
import { connect } from 'react-redux';
import Gallery from './gallery/Gallery';
import PortfolioNavBtns from './gallery/PortfolioNavBtns';


class Portfolio extends React.Component {
    //show hide images depending on selected btn
    selection = (btn) => {
        //alert('selection made ' + btn);
        let nameArray, i;
        //this is seeking out the images that got rendered on the Gallery.js
        //Those images have a 'column' class we can use to extract the images into nameArray.
        //column is a class name found in all the List item images, i can use it to grab all list items into an array
        nameArray = document.getElementsByClassName("column");
        if (btn === "all") btn = "";
        for (i = 0; i < nameArray.length; i++) {
            this.RemoveClass(nameArray[i]);
            //let showme = nameArray[i].className.indexOf(btn); //if btn = "",  will always give 0, which is greater than -1
            //append class 'hide' back where appropriate         
            if (nameArray[i].className.indexOf('dummy') > 0)  continue; //don't hide dummy images they serve a purpose in filling out the final row of images on the portfolio page       
             else if (nameArray[i].className.indexOf(btn) < 0) 
                 this.AddHideClass(nameArray[i]);   
        }
    };

    //hide images we don't want to show
    AddHideClass = (element) => {
        element.className += " hide";
    };

    // remove 'hide' class from all images so we can assign it back for images we don't want to show
    //blindly remove the 'hide' class names everywhere they are found.
    //1)This method will split the class names of the element into an array
    //2)This method finds and removes  'hide' while keeping remaining class names.
    //3)This method re-creates a final class from the remaining class names by concatonation of the
    //   remaining elements into a string result (with a space delimiter between the former elements)
    RemoveClass = (element) => {
        let arr1 = element.className.split(" ");
        while (arr1.indexOf("hide") > -1) {
            arr1.splice(arr1.indexOf("hide"), 1);
        }
        element.className = arr1.join(" ");
    };

    //doing this from NavBar now
    // hidePortfolioLink = () => {
    //     let portfolioLink = document.getElementById('portfolio-link');
    //     portfolioLink.className = 'dimNavLink';
    // };


    componentDidMount = () => {
        //These are not the same as the buttons found on PortfolioNavBtns.js
        const btns = {
            btn1: "all",
            btn2: "birds",
            btn3: "butterflies",
            btn4: "insects",
            btn5: "flora",
            btn6: "landscape"
        }

        console.log("Initializing Photography.Portfolio...");
        //PortfolioNavBtns.js
        let btn1 = document.getElementById('btn1');
        let btn2 = document.getElementById('btn2');
        let btn3 = document.getElementById('btn3');
        let btn4 = document.getElementById('btn4');
        let btn5 = document.getElementById('btn5');
        let btn6 = document.getElementById('btn6');

        btn1.onclick = () => {
            this.selection(btns.btn1);
            btn1.className = btn1.className.replace(" hide", " show");
            btn2.className = btn2.className.replace(" hide", " show");
            btn3.className = btn3.className.replace(" hide", " show");
            btn4.className = btn4.className.replace(" hide", " show");
            btn5.className = btn5.className.replace(" hide", " show");
            btn6.className = btn6.className.replace(" hide", " show");
        };
        btn2.onclick = () => {
            this.selection(btns.btn2);
            btn3.className = btn3.className.replace("show", "hide");
            btn4.className = btn4.className.replace("show", "hide");
            btn5.className = btn5.className.replace("show", "hide");
            btn6.className = btn6.className.replace("show", "hide");

        };
        btn3.onclick = () => {
            this.selection(btns.btn3);
            btn2.className = btn2.className.replace("show", "hide");
            btn4.className = btn4.className.replace("show", "hide");
            btn5.className = btn5.className.replace("show", "hide");
            btn6.className = btn6.className.replace("show", "hide");
        };
        btn4.onclick = () => {
            this.selection(btns.btn4);
            btn2.className = btn2.className.replace("show", "hide");
            btn3.className = btn3.className.replace("show", "hide");
            btn5.className = btn5.className.replace("show", "hide");
            btn6.className = btn6.className.replace("show", "hide");
        };
        btn5.onclick = () => {
            this.selection(btns.btn5);
            btn2.className = btn2.className.replace("show", "hide");
            btn3.className = btn3.className.replace("show", "hide");
            btn4.className = btn4.className.replace("show", "hide");
            btn6.className = btn6.className.replace("show", "hide");
        };
        btn6.onclick = () => {
            this.selection(btns.btn6);
            btn2.className = btn2.className.replace("show", "hide");
            btn3.className = btn3.className.replace("show", "hide");
            btn4.className = btn4.className.replace("show", "hide");
            btn5.className = btn5.className.replace("show", "hide");
        };
        //doing this from NavBar now
        //this.hidePortfolioLink();
        this.selection("all");

        //this is an additional click event (above and beyond the natural click event that DOM elements already have)
        //we need this click event handler to deal with toggling the 'active' class
        const navBtns = [...document.getElementsByClassName('btn')];
        navBtns.forEach(function (btn, index) {
            //alert('register index ' + index);
            btn.addEventListener("click", function () {
                //alert('click detected ' + index);
                //returns an array of 'active', but, there will only ever be one in our case
                let current = document.getElementsByClassName("active");
                //remove the 'active' class
                current[0].className = current[0].className.replace(" active", "");
                //now set 'active class' on the btn that was clicked
                btn.className += " active";
            });
        });
    }

    render() {
        return (
            <Gallery images={this.props.portfolioImages}>
                <PortfolioNavBtns />
            </Gallery>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        portfolioImages: state.portfolioImages
    };
}

export default connect(mapStateToProps)(Portfolio);


